import React from "react";
import {css} from "@panda/css";
import classNames from "classnames";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {AddToFavouritesButton} from "../../../my_offers/components/AddToFavouritesButton";
import {IOfferDetail} from "../../../offer/types/IOfferDetail";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {LeadSidebarForm} from "./LeadSidebarForm";

interface IProps {
    vendor: {
        name: string;
        id: number;
        logo: {
            v_log_80x60: string;
            v_log_106x80?: string;
            v_log_120x90: string;
            v_log_160x120: string;
        } | null;
    };
    offerId: IOfferDetail["id"];
    propertyId?: IPropertyDetail["id"];
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    sidebarBg?: "light" | "dark";
    blockScrolling?: boolean;
}

export const LeadSidebarVariantB = (props: IProps) => {
    return (
        <div>
            <div className={classNames(boxWrapper, !props.blockScrolling && scrollableStyle)}>
                <div className={vendorInfoWrapper}>
                    <Image width="80px" height="60px" alt="zdjęcie konsultanta" src={props.vendor.logo?.v_log_80x60} className={imgStyle} />
                    <div>
                        <Text variant="headline_6" as="p" strong>
                            Zapytaj o pełną ofertę
                        </Text>
                        <Text variant="body_copy_2">{props.vendor.name}</Text>
                    </div>
                </div>

                <LeadSidebarForm
                    vendorId={props.vendor.id}
                    offerId={props.offerId}
                    propertyId={props.propertyId}
                    source={props.source}
                    sourceSection={props.sourceSection}
                />
            </div>

            {props.propertyId && props.offerId && (
                <div className={addToFavouritesButtonWrapStyle}>
                    <AddToFavouritesButton
                        className={addToFavouritesButtonStyle}
                        propertyId={props.propertyId}
                        offerId={props.offerId}
                        theme={props.sidebarBg ? props.sidebarBg : "light"}
                    />
                </div>
            )}
        </div>
    );
};

const boxWrapper = css({
    width: "100%",
    backgroundColor: "white",
    height: "fit-content",
    borderRadius: 2,
    boxShadow: "0 16px 40px rgba(174,177,180,0.2)",
    p: 1.5
});

const scrollableStyle = css({
    maxHeight: "calc(100vh - (var(--globals-baseUnit) * 25))",
    overflowY: "auto"
});

const imgStyle = css({
    minHeight: "60px",
    minWidth: "80px"
});

const vendorInfoWrapper = css({
    display: "flex",
    flexDirection: "row",
    gap: 2,
    justifyContent: "start",
    alignItems: "center",
    mb: 3
});

const addToFavouritesButtonWrapStyle = css({
    display: "flex",
    justifyContent: "center",
    marginTop: 2
});

const addToFavouritesButtonStyle = css({
    marginTop: 2
});
import React from "react";
import {css} from "@panda/css";
import classNames from "classnames";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {AddToFavouritesButton} from "../../../my_offers/components/AddToFavouritesButton";
import {IOfferDetail} from "../../../offer/types/IOfferDetail";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {LeadSidebarForm} from "./LeadSidebarForm";

interface IProps {
    vendor: {
        name: string;
        id: number;
        logo: {
            v_log_80x60: string;
            v_log_106x80?: string;
            v_log_120x90: string;
            v_log_160x120: string;
        } | null;
    };
    offerId: IOfferDetail["id"];
    propertyId?: IPropertyDetail["id"];
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    sidebarBg?: "light" | "dark";
    blockScrolling?: boolean;
}

export const LeadSidebarVariantB = (props: IProps) => {
    return (
        <div>
            <div className={classNames(boxWrapper, !props.blockScrolling && scrollableStyle)}>
                <div className={vendorInfoWrapper}>
                    <Image width="80px" height="60px" alt="zdjęcie konsultanta" src={props.vendor.logo?.v_log_80x60} className={imgStyle} />
                    <div>
                        <Text variant="headline_6" as="p" strong>
                            Zapytaj o pełną ofertę
                        </Text>
                        <Text variant="body_copy_2">{props.vendor.name}</Text>
                    </div>
                </div>

                <LeadSidebarForm
                    vendorId={props.vendor.id}
                    offerId={props.offerId}
                    propertyId={props.propertyId}
                    source={props.source}
                    sourceSection={props.sourceSection}
                />
            </div>

            {props.propertyId && props.offerId && (
                <div className={addToFavouritesButtonWrapStyle}>
                    <AddToFavouritesButton
                        className={addToFavouritesButtonStyle}
                        propertyId={props.propertyId}
                        offerId={props.offerId}
                        theme={props.sidebarBg ? props.sidebarBg : "light"}
                    />
                </div>
            )}
        </div>
    );
};

const boxWrapper = css({
    width: "100%",
    backgroundColor: "white",
    height: "fit-content",
    borderRadius: 2,
    boxShadow: "0 16px 40px rgba(174,177,180,0.2)",
    p: 1.5
});

const scrollableStyle = css({
    maxHeight: "calc(100vh - (var(--globals-baseUnit) * 25))",
    overflowY: "auto"
});

const imgStyle = css({
    minHeight: "60px",
    minWidth: "80px"
});

const vendorInfoWrapper = css({
    display: "flex",
    flexDirection: "row",
    gap: 2,
    justifyContent: "start",
    alignItems: "center",
    mb: 3
});

const addToFavouritesButtonWrapStyle = css({
    display: "flex",
    justifyContent: "center",
    marginTop: 2
});

const addToFavouritesButtonStyle = css({
    marginTop: 2
});
